<style></style>
<template>
  <div>
    <div class="content-box">
      <div
        class="support-index"
        :class="{ 'show-ticket-content': seleccionada }"
      >
        <div class="support-ticket-content-w">
          <div class="support-ticket-content">
            <div
              class="support-ticket-content-header mb-0"
              v-if="seleccionada"
              style="display: block"
            >
              <br />
              <a class="back-to-index" href="#" @click="ResetSelect()">
                <i class="os-icon os-icon-arrow-left"></i>
                <span>Atras</span>
              </a>
              <span
                class="ticket-header font-weight-bold"
                style="font-size: 15px"
                >Información de movimiento localización</span
              >
              <div>
                Estatus:
                <span
                  v-bind:class="{
                    'badge badge-danger': seleccionada.estado == '9',
                    'badge badge-success': seleccionada.estado == 'A',
                    'badge badge-warning ': seleccionada.estado == 'B',
                    'badge badge-dark': seleccionada.estado == 'C',
                  }"
                  >{{ seleccionada.estado_str }}</span
                >
                <br />
                Traslado #:
                <span class="text-success">{{ seleccionada.numero }}</span>
                <br />
                Tienda:
                <span class="text-success">{{
                  seleccionada.tienda.nombre
                }}</span>
                <br />
                Fecha:
                <span class="text-success">{{
                  seleccionada.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss a")
                }}</span>
                <br />
                Tipo traslado:
                <span class="text-success">{{ seleccionada.tipo_str }}</span>
                <br />
                Usuario:
                <span class="text-success">{{
                  seleccionada.usuario.username
                }}</span>
              </div>
              <div></div>
              <br />
              <button
                class="btn btn-md btn-block btn-info"
                @click="verInventarioDeEstacion()"
              >
                Inventario de posición
              </button>
              <br />
              <!-- Boton de acciones flotantes start  -->
              <!--div class="fab fab-5">
                <div class="mainop">
                  <i id="addIcon"><i class="fas fa-plus"></i></i>
                </div>
                <div
                  class="contenedor activity-boxes-w"
                  style="background-color: #ccc; padding: 4px"
                >
                  <button
                    class="activity-box btn-sm btn-block"
                    style="margin-top: 0.14rem; padding: 0.4rem"
                    :disabled="!(current.estado != 'B')"
                    @click="abrirModalGenerarIngreso()"
                  >
                    <div class="activity-avatar">
                      <i class="fas fa-dolly fa-2x"></i>
                    </div>
                    <div class="activity-info">
                      <span class="font-weight-bold"
                        >Generar Ingreso Producto
                      </span>
                    </div>
                  </button>
                  <button
                    class="activity-box btn-sm btn-block"
                    style="margin-top: 0.14rem; padding: 0.4rem"
                    @click="imprimir()"
                  >
                    <div class="activity-avatar">
                      <i class="fa fa-print fa-2x"></i>
                    </div>
                    <div class="activity-info">
                      <span class="font-weight-bold">Imprimir</span>
                    </div>
                  </button>
                </div>
              </div-->
              <!-- Boton de acciones flotantes END  -->
              <br />
              <div class="row">
                <div class="col-6" style="padding-top: 10px">
                  <h6 class="text-success font-weight-bold">Detalle Picking</h6>
                </div>
                <div class="col-6 text-right">
                  <div class="btn-group dropup mr-1 mb-1">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-success dropdown-toggle"
                      data-toggle="dropdown"
                      id="dropdownMenuButton5"
                      type="button"
                    >
                      <i class="os-icon os-icon-ui-46"> </i> Opciones
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton5"
                      class="dropdown-menu dropdown-menu-right"
                    >
                      <a
                        class="dropdown-item btn-lg"
                        href="#"
                        :disabled="!(current.estado != 'B')"
                        @click="abrirModalGenerarIngreso()"
                      >
                        <i class="fas fa-dolly "></i>
                        Transferir de Carrito a Destino
                      </a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item btn-lg" href="#" @click="imprimir()">
                        <i class="fa fa-print "></i>
                        Imprimir Reporte Detallado Traslado
                      </a>
                        <div class="dropdown-divider"></div>
                      <a class="dropdown-item btn-lg" href="#" @click="ImprimirResumen()">
                         <i class="fa fa-file "></i>
                        Imprimir Resumen Traslado
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <ModalPickearComponent
                :current="seleccionada"
                @refreshCurrent="refreshData(seleccionada.id)"
              />
            </div>
            <TransferenciaLocDetalleComponent
              :current="seleccionada"
              @refreshCurrent="refreshData(seleccionada.id)"
            />
            <ExistenciasModalComponent
              :seleccionada="seleccionada"
              :existencias="existencias"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TransferenciaLocDetalleComponent from "@/components/wms/transferencia_localizacion/TransferenciaLocDetalleComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";
import ModalPickearComponent from "@/components/wms/transferencia_localizacion/ModalPickearComponent";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    TransferenciaLocDetalleComponent,
    ModalPickearComponent,
    TiendaSelectComponent,
    ExistenciasModalComponent,
  },
  data() {
    return {
      existencias: [],
      barra_posicion: "",
      barra: "",
      errors: "",
      seleccionada: null,
      current: {
        scan_barra: true,
        id: null,
        estado_str: null,
        tienda: "",
        estado: "",
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barrax.focus();
    });
    if (this.$route.params.id) {
      this.refreshData(this.$route.params.id);
    }
  },
  methods: {
    abrirModalGenerarIngreso() {
      $("#generarTrasladoModal").modal("show");
    },
    ResetSelect() {
      this.$router.push({ path: `/wms/movimiento-localizacion/` });
      this.seleccionada = null;
    },
    verInventarioDeEstacion() {
      $("#modalBarraPosicion").modal("show");
    },
    imprimir() {
      let det;
      det = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/movimiento_localizacion/reporte_traslado_loc.jrxml&requerimiento_id=${det}`
      );
    },
    ImprimirResumen() {
      let det
      det = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open (
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/movimiento_localizacion/resumen_movimiento_localizacion.jrxml&requerimiento_id=${det}`
      );
    },
    refreshData(id) {
      let self = this;
      DynamicService.getById("inv", "req_traslado_loc", id)
        .then((response) => {
          self.seleccionada = response.data;
        })
        .catch((error) => {
          this.ResetSelect();
          Notifications.alert.error(
            "Buscar transaccion stock",
            "No se encontro ninguna transaccion con ese dato"
          );
        });
    },
    refreshAll() {
      this.refreshData(this.seleccionada.id);
    },
  },
};
</script>
